import styled from 'styled-components'
import { Modal } from '../Modal'
import { Row, Column } from '../Grid'
import { Close } from '../Icons'
import { ScheduleConsultation } from './ScheduleConsultation'

const ScheduleConsultationModal = ({ professional, isModalOpen, toggleModal }) => {
  return (
    <Modal isOpened={isModalOpen} setIsOpened={toggleModal}>
      {({ innerModalRef }) => (
        <Column
          ref={innerModalRef}
          bg='white'
          borderRadius='6px'
          width='100%'
          maxWidth='970px'
          maxHeight='auto'
          boxShadow='0px 2px 12px #00000040'
          px={['12px', '32px']}
          py={21}
        >
          <Row justifyContent='flex-end'>
            <IconContainer onClick={toggleModal}>
              <Close size={14} />
            </IconContainer>
          </Row>
          <Row>
            <ScheduleConsultation professional={professional} isModal toggleModal={toggleModal} />
          </Row>
        </Column>
      )}
    </Modal>
  )
}

const IconContainer = styled(Row)`
  cursor: pointer;
  height: 16px;
  width: 16px;
`

export default ScheduleConsultationModal
